import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

const routes: Routes = [
  { path: '', loadChildren: () => import('./home/home.module').then(m => m.HomeModule)},

  { path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomeModule)},

  { path: 'atendimento', loadChildren: () => import('./atendimento/atendimento.module').then(m => m.AtendimentoModule) },

  { path: 'blog', loadChildren: () => import('./blog/blog.module').then(m => m.BlogModule) },

  { path: 'produto-detalhe', loadChildren: () => import('./produtos-detalhe/produto-detalhes.module').then(m => m.ProdutoModule) },

  { path: 'sobre', loadChildren: () => import('./Sobre-blukit/sobre.module').then(m => m.SobreModule) },

  { path: 'linhas', loadChildren: () => import('./categorias/categorias.module').then(m => m.CategoriasModule) },

  { path: 'onde-encontrar', loadChildren: () => import('./onde-encontrar/onde-encontrar.module').then(m => m.OndeEncontrarModule) },
  { path: 'onde-encontrar/assistencia-tecnica', redirectTo: 'onde-encontrar', pathMatch: 'full' },
  { path: 'onde-encontrar/lojistas-revendedores', redirectTo: 'onde-encontrar', pathMatch: 'full' },

  { path: 'blukit_mobile_sales_privacy_policy', loadChildren: () => import('./blukit_mobile_sales_privacy_policy/blukit_mobile_sales_privacy_policy.module').then(m => m.BlukitMobileSalesPrivacyPolicyModule) },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
